import { Snackbar } from "@mui/material";
import React, { createContext, useCallback, useContext, useState } from "react";
import MuiAlert from "@mui/material/Alert";

// Crear el contexto
const SnackbarContext = createContext();

//Hook para usar el contexto facilmente
export const useSnackbar = ()=>useContext(SnackbarContext);

//Componente Alert personalizado
const CustomAlert  = React.forwardRef(function Alert(props, ref){
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
});

//Provider que envuelve la app
export const SnackbarProvider=({children})=>{
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  // Función que otros componentes llamarán para mostrar una alerta
  const showSnackbar = useCallback(({message, severity='info'})=>{
    setSnackbar({
      open: true,
      message,
      severity
    });
  },[]);

  const handleClose=(event, reason)=>{
    if(reason==='clickaway') return;
    setSnackbar((prev)=>({...prev, open:false}));
  };

  return(
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <CustomAlert onClose={handleClose} severity={snackbar.severity} sx={{width:'100%'}}>
          {snackbar.message}
        </CustomAlert >
      </Snackbar>
    </SnackbarContext.Provider>
  );
}